module.exports = __webpack_public_path__ + "09020177a832c78d2f202fb9ece35fd2.svg";